import React, { useContext } from "react";
import { Store } from "../Store";
import TableButton from "./TableButton";

export default function Tables(props) {
  const {
    setTableTemp,
    tableTemp,
    selectedCompartment,
    compartments,
    setTableSelectedFromMain,
  } = props;

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { carts } = state;

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
        }}
      >
        {carts
          .filter((c, i) =>
            selectedCompartment
              ? c.tableNum >= selectedCompartment.startNum &&
                c.tableNum <= selectedCompartment.endNum
              : compartments && compartments.length > 0
              ? c.tableNum <= compartments[compartments.length - 1].endNum
              : c.tableNum <= 40
          )
          .map((c) => {
            return (
              <TableButton
                cartItems={c.cartItems}
                cart={c}
                key={c.tableNum}
                isSelected={c.tableNum === tableTemp}
                tableNum={c.tableNum}
                tableMinWitdh={"131px"}
                tableTemp={tableTemp}
                setTableTemp={setTableTemp}
                ctxDispatch={ctxDispatch}
                setTableSelectedFromMain={setTableSelectedFromMain}
              ></TableButton>
            );
          })}
      </div>
    </div>
  );
}
